import { Line } from 'react-chartjs-2';
import React from 'react';
import classNames from 'classnames/bind';
import styles from './styles.module.scss';

const cx = classNames.bind(styles);
export default function LineChart(props) {
  const state = {
    labels: [
      lableFormat(6),
      lableFormat(5),
      lableFormat(4),
      lableFormat(3),
      lableFormat(2),
      lableFormat(1),
      lableFormat(0),
    ],
    datasets: [
      {
        label: '정산금',
        fill: true,
        lineTension: 0.4,
        backgroundColor: 'rgba(254, 130, 86, 0.4)',
        borderColor: '#ff7851',
        borderWidth: 2,
        data: props.totalValue,
        font: {
          family: "'M PLUS 1', 'Noto Sans Kr'",
        },
      },
    ],
  };
  function lableFormat(preMonth) {
    let xMonth =
      parseInt(props.xMonth) - preMonth <= 0
        ? 12 + parseInt(props.xMonth) - preMonth
        : parseInt(props.xMonth) - preMonth;
    let xYear = props.xYear;
    if (xMonth === 1) {
      return `${xMonth}월(${xYear}년)`;
    } else {
      return `${xMonth}월`;
    }
  }
  var defaultOptions = {
    global: {
      defaultFont: "'M PLUS 1', 'Noto Sans Kr'",
    },
  };
  return (
    <div>
      <div className={cx('chart-label', props.classNames)}>
        <span></span>나의 남의집 정산금
      </div>
      <Line
        data={state}
        height={null}
        width={null}
        options={{
          aspectRatio: props.chartSize, // this would be a 1:1 aspect ratio
          animate: false,
          scales: {
            yAxes: {
              display: true,
              ticks: {
                fontFamily: "'M PLUS 1', 'Noto Sans Kr'",
                stepSize: 50000,
                min: 0,
                max: 200000,
                callback: function (value) {
                  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '원';
                },
                font: {
                  family: "'M PLUS 1', 'Noto Sans Kr'",
                },
              },
            },
            xAxes: {
              display: true,
              ticks: {
                font: {
                  family: "'M PLUS 1', 'Noto Sans Kr'",
                },
              },
            },
          },
          plugins: {
            legend: {
              display: false,
              labels: {
                font: {
                  family: "'M PLUS 1', 'Noto Sans Kr'",
                },
              },
            },
            filler: {
              propagate: false,
            },
          },
          interaction: {
            intersect: false,
          },
        }}
      />
    </div>
  );
}
